"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zeroSinceSS = exports.zeroSinceHH = void 0;
function zeroSinceHH(millisSinceEpoch) {
    return new Date(millisSinceEpoch).setUTCHours(0, 0, 0, 0);
}
exports.zeroSinceHH = zeroSinceHH;
function zeroSinceSS(millisSinceEpoch) {
    return new Date(millisSinceEpoch).setUTCSeconds(0, 0);
}
exports.zeroSinceSS = zeroSinceSS;
